import styled from "styled-components";
import { RgbColor, LightGrey, White, toString } from "../Color";

// TODO: PanelAppearanceData should probably replace PanelAppearance, also border and boxShadow should be split into more programmatic values rather than strings.

/** A panel appearance. */
interface PanelAppearanceData {

  /** The background color. */
  readonly backgroundColor: RgbColor;

  /** The border style. */
  readonly border: string;

  /** The box shadow style. */
  readonly boxShadow: string;

}

interface PanelAppearances {
  readonly [name: string]: PanelAppearanceData
}

/** The available appearances for the Panel. */
export const PanelAppearanceTable: PanelAppearances = {
  primary: {
    backgroundColor: White,
    border: `solid 1px ${toString(LightGrey["200"])}`,
    boxShadow: "0 0 0.25rem rgba(0, 0, 0, 0.08)",
  },
  secondary: {
    backgroundColor: LightGrey["50"],
    border: "none",
    boxShadow: "none",
  },
};

/** The Panel with the appearance styling applied. */
export const StyledPanel = styled.div<{ appearance: PanelAppearanceData }>`
  padding: 1.5rem 1.5rem;
  border: ${({ appearance }) => appearance.border};
  border-radius: 0.25rem;
  background-color: ${({ appearance }) => toString(appearance.backgroundColor)};
  box-shadow: ${({ appearance }) => appearance.boxShadow};
`;
